<template>
  <v-data-table
    :headers="text.pages.userHistory.tableHeaders"
    :items="userHistory.order"
    :single-expand="singleExpand"
    item-key="order_number"
    show-expand
    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="text.fields.search"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <table cellspacing="10">
          <tr>
            <th v-for="header in text.pages.userHistory.detailHeaders"
                :key="header.name"
                class="text-left"
            >
              {{ header.name }}
            </th>
          </tr>
          <tr v-for="row in item.detail" :key="row.id">
            <td v-for="header in text.pages.userHistory.detailHeaders" :key="header.name + row.id">
              {{ row[header.column] }}
              <v-divider/>
            </td>
          </tr>
          <tr>
            <td><strong>{{ text.pages.userHistory.deliveryType }}</strong></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3">
              <v-divider></v-divider>
            </td>
          </tr>
          <tr>
            <td>{{ item.delivery_name }}</td>
            <td></td>
            <td>{{ item.delivery_price_gross }}</td>
          </tr>
          <tr>
            <td colspan="3">
              <v-divider></v-divider>
            </td>
          </tr>
          <tr>
            <td><strong>{{ text.pages.userHistory.paymentType }}</strong></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>{{ item.payment_name }}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3">
              <v-divider></v-divider>
            </td>
          </tr>
          <tr>
            <td><strong>{{ text.pages.userHistory.deliveryAddress }}</strong></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3">
              {{ item.first_name }} {{ item.last_name }}<br>
              {{ item.address }}<br>
              {{ item.zip }} {{ item.city }}<br>
              {{ text.fields.email }} {{ item.email }}<br>
              {{ text.fields.phone }} {{ item.phone }}<br>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <v-divider></v-divider>
            </td>
          </tr>
          <tr>
            <td><strong>{{ text.pages.userHistory.additionalInfo }}</strong></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3" v-text="item.notice">
            </td>
          </tr>
        </table>
      </td>
    </template>
  </v-data-table>
</template>

<script>

import { translations } from '@/lang/translations';

export default {
  name: 'UserHistoryTable',
  props: ['userHistory'],
  computed: {
    text() {
      return translations[this.$store.state.language];
    },
  },
  data() {
    return {
      search: '',
      expanded: [],
      singleExpand: true,
      dessertHeaders: [
        {
          text: 'Dessert (100g serving)',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Calories', value: 'calories' },
        { text: 'Fat (g)', value: 'fat' },
        { text: 'Carbs (g)', value: 'carbs' },
        { text: 'Protein (g)', value: 'protein' },
        { text: 'Iron (%)', value: 'iron' },
        { text: '', value: 'data-table-expand' },
      ],
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: '1%',
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: '1%',
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: '7%',
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: '8%',
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: '16%',
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: '0%',
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: '2%',
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: '45%',
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: '22%',
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: '6%',
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>
